module.exports = __webpack_public_path__ + "static/media/success.d47c9775.png";